module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<h1>TOOLS</h1>\n\n<li>Poller Command:\n';
}
return __p;
};
